import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import {  toast } from 'react-toastify';
import '../../../assets/style/style.css';
import CircularProgress from '@mui/material/CircularProgress';
import { useParams, useNavigate } from 'react-router-dom';
import Config from "../../../config.js";
import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { handleErrors } from "common.js";
import { TextField } from '@mui/material';
import FormHelperText from '@mui/material/FormHelperText';
function ReturnProductDispose(props) {
  const { returnID, returnQuantity, openReturnProductDisposeModel, setPageContent, setOpenReturnProductDisposeModel } =  props;  
  const navigate    = useNavigate();
  const { t }       = useTranslation();
  const baseUrl     = Config.baseUrl;
  const bearerToken = `Bearer ${localStorage.getItem('JWTToken')}`;
  const [disposeSubmitIsLoading, setDisposeSubmitIsLoading] = useState(false);

  const [disposeQuantity, setDisposeQuantity] = useState("");
  const [disposeQuantityError, setDisposeQuantityError] = useState(false);
  const [disposeQuantityHelperText, setDisposeQuantityHelperText] = useState('');
           
  const handleReturnProductDisposeModelClose = () => { setOpenReturnProductDisposeModel(false) };

  const handleChangeDisposeQuantity = (event) => {

    const newValue = event.target.value;

    if(newValue <= returnQuantity) {
      setDisposeQuantity(newValue);
      setDisposeQuantityError(false);
      setDisposeQuantityHelperText('');
    }
  };
 
  const handleReturnProductDisposeSubmit = () => {
    
    let disposeQuantityValue = (disposeQuantity === "") ? 0 : disposeQuantity;

    if(parseInt(disposeQuantityValue) < 0)
    {
        setDisposeQuantityError(true);
        setDisposeQuantityHelperText(t("Please enter a valid dispose quantity"));
        return;
    }

    if(parseInt(disposeQuantityValue) > returnQuantity)
    {
        setDisposeQuantityError(true);
        setDisposeQuantityHelperText(t("Dispose quantity should be less than or equal to return quantity"));
        return;
    }

    let requestPayLoad = { 
                            returnID: returnID, 
                            restockQuantity: parseInt(returnQuantity)-parseInt(disposeQuantityValue),
                         };

    setDisposeSubmitIsLoading(true);
    axios({      
          url     : baseUrl+"/return/dispose",
          data    : requestPayLoad,
          method  : "POST",
          headers : {
            Authorization   : bearerToken,
            function        : Config.FUNCTION_KEY
          },        
        }).then(function (response) 
        {
            setDisposeSubmitIsLoading(false);       

            const responseData           = response.data;
            const responseDataStatusCode = responseData.status ? responseData.status : 0;
            const responseMessage        = responseData.message ? responseData.message : '';
            const responseStatusCode     = response.status;

            if(responseStatusCode === 200)
            {                
                (responseDataStatusCode === 1) ? toast.success(t(responseMessage)) : toast.error(t(responseMessage));
                    
                if(responseDataStatusCode === 1 && responseData && responseData.data)
                {
                  setPageContent(responseData.data);
                  handleReturnProductDisposeModelClose();
                }
            }        
            else 
            {
              toast.error(t('An unexpected error occurred while communicating with server'));
              return;            
            }   
        }).catch(function (error) {
          setDisposeSubmitIsLoading(false);  
          handleErrors(error, t, navigate);
        });
  }
  
  const returnProductDisposeModelLoad = () => {
    return (
        <Dialog open={openReturnProductDisposeModel} onClose={handleReturnProductDisposeModelClose}
          sx={{
            '& .MuiDialog-paper': {
              maxWidth: '350px', 
            },
          }}
        >
          <DialogTitle id="return-product-dispose" onClose={handleReturnProductDisposeModelClose}>
            {t("Product Dispose")}  
          </DialogTitle>         
          <DialogContent dividers>           

            <Grid container spacing={2} my={1}>
                <Grid item xs={12}>
                    <FormControl sx={{ margin: '10px 0px', width: '100%' }}>
                      <TextField 
                        type = "number"
                        label = {t('Return Quantity')}
                        variant = "outlined" 
                        value = {returnQuantity}   
                        disabled
                        readOnly                     
                      />                      
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControl sx={{ margin: '10px 0px', width: '100%' }}>
                      <TextField 
                        type = "number"
                        label = {t('Dispose Quantity')}
                        variant = "outlined" 
                        value = {disposeQuantity}
                        inputProps={{
                          min: 0,
                          max: returnQuantity
                        }}
                        onChange={handleChangeDisposeQuantity}   
                        error={disposeQuantityError}
                      />
                      <FormHelperText sx={{ position: 'absolute', bottom: -20, right: 0, color: 'red' }}>
                        {disposeQuantityHelperText}
                      </FormHelperText>
                    </FormControl>
                </Grid>
                {!(disposeQuantity === "") ?
                  <Grid item xs={12}>
                      <FormControl sx={{ margin: '10px 0px', width: '100%' }}>
                        <TextField 
                          type = "number"
                          label = {t('Restock Quantity')}
                          variant = "outlined" 
                          value = {returnQuantity-disposeQuantity}      
                          disabled
                          readOnly                  
                        />                      
                      </FormControl>
                  </Grid>
                : null}
              </Grid>  
              
          <Container className="buttonContainer">
            <Box>
              <Button key={"button-1"}                    
                variant="contained" 
                sx={{color : '#FFFFFF', height : 45, margin: '10px'}} 
                onClick={handleReturnProductDisposeSubmit}
                disabled={disposeSubmitIsLoading}>
                {t("Submit")}                    
              </Button>
              <Button key={"button-2"}                     
                variant="contained" 
                sx={{color : '#FFFFFF', height : 45, margin: '10px'}} 
                onClick={handleReturnProductDisposeModelClose}
                disabled={disposeSubmitIsLoading}>
                {t("close")}                    
              </Button>

              {disposeSubmitIsLoading ?       
              <Box className='circularLoadingModelOuter'>   
                <CircularProgress size={30} className='circularLoadingModel' />
              </Box>
            : <></>}
            </Box>
        </Container>
      </DialogContent>
    </Dialog>  
    );
  }

  return (
          <>
          {returnProductDisposeModelLoad()}
          </>
         );
}
export default ReturnProductDispose;
